import { render, staticRenderFns } from "./SocialAppeal.vue?vue&type=template&id=797c893c&scoped=true"
import script from "./SocialAppeal.vue?vue&type=script&lang=js"
export * from "./SocialAppeal.vue?vue&type=script&lang=js"
import style0 from "./SocialAppeal.vue?vue&type=style&index=0&id=797c893c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797c893c",
  null
  
)

export default component.exports